/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import Link from 'next/link'
import Image from 'components/core/Image'
import styles from './styles.module.scss'

const NavigationItem = ({ store, permalink, index, storeToShow, setStoreToShow }) => {
  const { images = [], city, name } = store

  const handleClick = () => {
    if (storeToShow === permalink) {
      return setStoreToShow(null)
    }

    return setStoreToShow(permalink)
  }

  return (
    <div className={styles.stores__item}>
      <Link
        href={`/stores/${permalink}`}
        shallow
        scroll={false}
        className={styles.stores__link}
        onClick={handleClick}
        tabIndex={index}
        role="link"
      >
        <Image
          height={80}
          width={80}
          src={images[0]?.path}
          containerClassName={styles.stores__image}
          alt={name}
        />
        <h4 className={styles.stores__city}>{city}</h4>
      </Link>
    </div>
  )
}

export default NavigationItem
